/* global femcare */

/**
 * Handles label collection for ICH forms.
 * On submit, it finds associated labels for input, select, and textarea fields
 * and appends their text as hidden inputs to the form.
 */
femcare.ichLabelCollector = {
    /**
     * Initializes the label collector for ICH forms.
     * Adds a submit handler to each form with class "ich-form".
     */
    init() {
        const ichForms = document.querySelectorAll('form.ich-form');
        if (ichForms.length) {

            ichForms.forEach((form) => {

                const elements = form.querySelectorAll('input, select, textarea');

                elements.forEach((input) => {
                    const id = input.id;
                    const name = input.name;
                    if (!id || !name) {
                        return;
                    }

                    const labelEl = Array.from(document.querySelectorAll('label')).find((label) => {
                        const f = label.getAttribute('for');
                        return f === id || f === `${id}-button`;
                    });

                    let labelText = input.dataset.label || '';
                    if (!labelText && labelEl) {
                        labelText = labelEl.textContent.replace(/\s+/g, ' ').trim();
                    }

                    if (labelText) {
                        const hidden = document.createElement('input');
                        hidden.type = 'hidden';
                        hidden.name = `${name}_Label`;
                        hidden.value = labelText;
                        form.appendChild(hidden);
                    }
                });

            });
        }
    },
};
